import * as Yup from "yup";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
export  const validationUserServiceSchema = Yup.object().shape({
    services: Yup.array()
      .min(1, "Please select at least one service.")
      .required("This field is required."),
  });



  export  const RegistrationAddressValidationSchema = Yup.object({
    postCode: Yup.string().required("Post code is required"),
    address: Yup.string().required("Address is required"),
    radiusCover: Yup.number()
      .typeError("Radius must be a number")
      .positive("Radius must be greater than 0")
      .required("Radius Covered (Miles) is required"),
  })


  export const setPassvalidateSchema = Yup.object().shape({
    newpassword:Yup.string().required("This field is required"),
    confirmedpassword:Yup.string().required("This field is required").oneOf([Yup.ref('newpassword')], 'Passwords must match') ,
  });



  

  export const BasicsProfilevalidationSchema = Yup.object({
    bussinessName: Yup.string()
      .required("Business Name is required")
      .min(3, "Business Name must be at least 3 characters"),
    // companySize: Yup.string().required("Company Size is required"),


      companyType: Yup.string().required("Company type is required"),
    
      companySize: Yup.string().when('companyType', {
        is: 'LimitedCompany',
        then: (schema) => schema.required("Company size is required"),
        otherwise: (schema) => schema.notRequired()
      }),
    
    incorporationDate: Yup.date()
      .required("Incorporation Date is required")
      .typeError("Invalid date format"),
    description: Yup.string()
      .required("Description is required").test(
        'is-not-empty',
        'Description is required',
        (value) => value && value.replace(/<(.|\n)*?>/g, '').trim() !== ''
      )
  });



  export const  LocationvalidationSchema = Yup.object({
    postCode: Yup.string()
      .required("Post code is required"),
      address: Yup.string()
      .required("Address is required"),
      radiusCover: Yup.string()
      .required("Service Radius is required"),
  });


    // Validation schema using Yup
    export const PortfolioDetailvalidationSchema = Yup.object({
      projectName: Yup.string()
        .min(2, "Project name must be at least 2 characters")
        .required("Project name is required"),
      // category: Yup.array().min(1, "At least one category is required"),
    });



   export const GetVerifiedValidationSchema = Yup.object({
    companyRegisterNo: Yup.string().required("Registration Number is required"),
    govermentBodyListedWith: Yup.string().required("Body is required"),
    RegisterNo: Yup.string().required("Registration Number is required"),
    insurancePolicyNo: Yup.string().required("Insurance  Number is required"),
    image: Yup.mixed().required("Document is required"),
    document: Yup.mixed().required("Document is required"),
    
  });


  export const EmployeeValidationSchema = Yup.object({
    employeeName: Yup.string().required("Employee name is required"),
    jobRole: Yup.string().required("Job role is required"),
    // joiningDate: Yup.date().required("Joining date is required"),
    qualification: Yup.string().required("Qualification is required"),
  });


  export const secondStepValidationSchema = Yup.object({
    subcategories: Yup.array()
      .min(1, "Please select at least one category")  // Ensures that at least one subcategory is selected
      .required("Please select a category")  // Makes the field required
  });






  export const EnquiryThreeValidation = Yup.object({
    businessType: Yup.string().required('This field is required'),
  });


  export const propertyTypeValidation = Yup.object({
    propertyType: Yup.string().required('This field is required'),
  });




  export const EnquiryFourValidation = Yup.object({
    needType: Yup.string().required('This field is required'),
  });

  export const EnquiryFiveValidation = Yup.object({
    taskDescription: Yup.string().required('This field is required'),
   
  });


  export const EnquirysixValidation = Yup.object({
    quotation: Yup.string().required('This field is required'),
  });


  export const EnquirySevenValidation = Yup.object({
    // estimatedBudget: Yup.string()
    //   .required('This field is required')
    //   .matches(/^\d+$/, 'This field must be a number') // Ensures input is numeric
    //   .test(
    //     'min-max-range',
    //     'Value must be between 0 and 20,000',
    //     (value) => {
    //       const num = Number(value);
    //       return num >= 0 && num <= 20000;
    //     }
    //   ),
  });

  export const EnquiryEightValidation = Yup.object({
    decisionType: Yup.string().required('This field is required'),
   
  });



  export const EnquiryNineValidation = Yup.object({
    postCode: Yup.string().required("Post code is required"),
    address: Yup.string().required("Address is required"),
  });

  export const EnquiryTenValidation = Yup.object({
    city: Yup.string().required("City  is required"),
  });



  export const customerPasswordSet = Yup.object({
    password: Yup.string()
        .required("New Password is required")
        .min(6, "Password must be at least 6 characters"),
        confirmPassword: Yup.string()
        .required("Please confirm your new password")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });


  export const customerOtpSet = Yup.object({
    otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
    .required("OTP is required"),
  });


  export const EnquiryElevenValidation = Yup.object({
    phoneNumber:Yup.string()
    .required("Phone number is required").matches(phoneRegExp, 'Phone number is not valid'),
    email:Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
    name: Yup.string().required("Name is required"),
})


export const  CustomerAccountValidationSchema =  Yup.object({
  email: Yup.string()
  .email("Invalid email format")
  .required("Contact Email Address is required"),
  name: Yup.string().required("Name is required"),
  postCode: Yup.string().required("Post code is required"),
  address: Yup.string().required("Address is required"),
  phoneNumber: Yup.string().required("Phone number is required").matches(phoneRegExp, 'Phone number is not valid'),
  // image: Yup.mixed().nullable(),
})





export const  ContactInfoValidation = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Contact Email Address is required"),
    phoneNumber:Yup.string().required("Phone number is required").matches(phoneRegExp, 'Phone number is not valid'),
  });
